import { useContainer } from '../../../hooks/useContainer';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from '../../useTranslation';
import { PolicyAndMedicalLeaveBaseDto } from '../../../commonTypes/organization.types';

const useHttpDeletePolicy = (setPolicies: Dispatch<SetStateAction<PolicyAndMedicalLeaveBaseDto[]>>) => {
    const { t } = useTranslation('newNotifications');
    const organizationApi = useContainer(OrganizationApi);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = (id: string) => {
        const { exec, abort } = organizationApi.deletePolicy({
            params: { id },
            onSuccess: () => {
                setPolicies(prev => prev?.filter(policy => policy.id !== id));
                toastHandler.push('success', t('policy.deleteTitle'), t('policy.deleteSuccess'));
            },
            onError: err => {
                if (err === 'Cannot delete the last active policy.') {
                    toastHandler.push('error', t('policy.deleteTitle'), t('policy.cannotDeleteLastActivePolicy'));
                } else {
                    toastHandler.push('error', t('policy.deleteTitle'), t('policy.deleteError'));
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpDeletePolicy;
